import { useParams, useHistory } from 'react-router-dom';
import {
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
  IonBackButton, IonButtons,
} from '@ionic/react';
import { JobEditPanel } from '@/components/jobs/JobEditPanel';
import { NoindexSeo } from '@/components/NoindexSeo';

export function JobEditPage() {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  return (
    <IonPage>
      <NoindexSeo />
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start"><IonBackButton defaultHref="/employer/jobs" /></IonButtons>
          <IonTitle>Edit job</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <JobEditPanel
          jobId={id}
          onSaved={() => history.push('/employer/jobs')}
          onCancel={() => history.goBack()}
        />
      </IonContent>
    </IonPage>
  );
}
